import React from 'react'
import { about, about1, about2, about3, blogs1, product1, product2, product3, product4 } from '../../assets/images';
import Others from './Others';
import { useTranslation } from 'react-i18next';


const KampaniyaDetail = () => {

  const { t, i18n } = useTranslation();
  return (
      <div className="md:max-w-container max-w-containerSm mx-auto mt-[40px] md:mt-[88px]">
    <p className='mb-[20px] font-semibold text-lg md:text-2xl md:font-medium'>Lorem ipsum dolor sit amet, consectetur adipiscing elit</p>
   <div className='md:flex'>
    <div>
   <img className='md:w-[502px] w-full' src={blogs1}></img>
    </div>
    <div className='md:ml-[40px] md:w-[757px] mt-[18px] md:mt-0'>
       <div>
        <p className='text-[16px]'>{t("2019-cu ildə sənayedə yerini alan dermokosmetik markamız TANURA elmi məlumatlara əsaslanan və biotexnoloji aktivlər, dərman bitkiləri ekstraktları, dərman bitkiləri yağları, vitaminlər ilə yaradılan formulaları ilə hər cür dəri problemlərinə hədəfə yönəlmiş həllər təklif edir., amin turşuları və güclü antioksidantlar, eyni zamanda sağlam dərinin formalaşmasını dəstəkləyir. Tanura Ar-Ge laboratoriyalarında ideyadan istehsala qədər olan proses titizliklə idarə olunur və sizə çatdırılır, qeyri-adi nəticələrlə xoş dəriyə qulluq təcrübəsi təqdim edilir. Vizyonumuz etik dəyərlərimiz və yenilikçi anlayışımızla yerli və beynəlxalq müştərilərimizlə eyni məqsədə doğru böyümək və irəliləməkdir. Tanura günəşin doğuşu deməkdir. Dəriniz TANURA ilə hər gün yenilənsin və yenidən doğulsun...")}</p>
       </div>
    </div>
   </div>
  </div>
  )
}

export default KampaniyaDetail